import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const Navbar = ({ color }) => (
  <div className="rounded overflow-hidden border-b-2 shadow bg-white mb-3">
    <div className="border-b border-grey-light p-4">
      <ul className="list-reset flex">
        <li className="mr-8">
          <NavLink
            to="/"
            activeClassName={`text-red-darker`}
            className={`no-underline text-${color} hover:text-${color}-darker`}
          >
            {window.app_name}
          </NavLink>
        </li>
        <li className="mr-6">
          <a
            className={`no-underline hover:underline text-${color} hover:text-${color}-darker`}
          >
            Movies
          </a>
        </li>
        <li className="mr-6">
          <a
            className={`no-underline hover:underline text-${color} hover:text-${color}-darker`}
          >
            Tv Shows
          </a>
        </li>
        <li className="mr-6">
          <a
            className={`no-underline hover:underline text-${color} hover:text-${color}-darker`}
          >
            People
          </a>
        </li>
      </ul>
    </div>
  </div>
);

Navbar.defaultProps = {
  color: "blue"
};

Navbar.propTypes = {
  color: PropTypes.string
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js